// extracted by mini-css-extract-plugin
export default {"formTextarea":"FormTextarea_formTextarea__x2Am8","formTextarea__title":"FormTextarea_formTextarea__title__l4mOh"};